import { render } from "./CopyTradeResult.vue?vue&type=template&id=3ffd23f0&ts=true"
import script from "./CopyTradeResult.vue?vue&type=script&lang=ts"
export * from "./CopyTradeResult.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__